module.exports = "/assets/data/cc57837a90cfb491c90d5f9262ad9fda-M7.data.json";